import { gql } from "@apollo/client";

export const CREATE_COMMENT = gql`
  mutation createComment($input: CreateCommentInput!) {
    createComment(input: $input) {
      id
      success
    }
  }
`;
